import { __module as combinator } from "../../../../../../../_virtual/combinator.js";
import { __require as requireNode } from "./node.js";
import { __require as requireTypes } from "./types.js";
var hasRequiredCombinator;
function requireCombinator() {
  if (hasRequiredCombinator) return combinator.exports;
  hasRequiredCombinator = 1;
  (function(module, exports$1) {
    exports$1.__esModule = true;
    exports$1["default"] = void 0;
    var _node = _interopRequireDefault(requireNode());
    var _types = requireTypes();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
        o2.__proto__ = p2;
        return o2;
      };
      return _setPrototypeOf(o, p);
    }
    var Combinator = /* @__PURE__ */ (function(_Node) {
      _inheritsLoose(Combinator2, _Node);
      function Combinator2(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = _types.COMBINATOR;
        return _this;
      }
      return Combinator2;
    })(_node["default"]);
    exports$1["default"] = Combinator;
    module.exports = exports$1.default;
  })(combinator, combinator.exports);
  return combinator.exports;
}
export {
  requireCombinator as __require
};
//# sourceMappingURL=combinator.js.map
